import { parseCurrencyInputNumber } from "@/lib/formatter";

const toPricedRows = (option) => {
  const variantGroups = option.service_option_variants || [];

  // Prices live on the variants when the option has any.
  if (variantGroups.length === 0) {
    return [
      {
        label: option.service_title,
        isNotSale: option.is_not_sale,
        appointmentPrices: option.service_appointment_prices,
      },
    ];
  }

  return variantGroups.flatMap((group) =>
    (group.variants || []).map((variant) => ({
      label: `${option.service_title} / ${group.title} / ${variant.title}`,
      isNotSale: variant.is_not_sale,
      appointmentPrices: variant.appointment_prices,
    }))
  );
};

/**
 * Returns the label of the first sellable row with an empty per-visit price, or null.
 * The finance export books each visit's revenue from this price and counts an empty one as zero.
 */
export function findEmptyAppointmentPriceRow(packageOptions) {
  const emptyRows = (packageOptions || [])
    .flatMap(toPricedRows)
    .filter((row) => row.isNotSale !== true)
    .map((row) => ({
      label: row.label,
      emptyAppointment: (row.appointmentPrices || []).find(
        (appointmentPrice) =>
          parseCurrencyInputNumber(appointmentPrice.appoint_price) === null
      ),
    }))
    .filter((row) => row.emptyAppointment);

  return emptyRows.length > 0
    ? `${emptyRows[0].label} (ครั้งที่ ${emptyRows[0].emptyAppointment.appoint_no})`
    : null;
}
